import Vue, { VueConstructor } from 'vue';
import { Logger } from '@/services/logger/logger';

export function registerAllCmgComponents(logger: Logger) {
  const context = require.context('./', true, /\.vue$/);
  loadComponentsFromContext(context, logger);
}

function loadComponentsFromContext(context: __WebpackModuleApi.RequireContext, logger: Logger) {
  const components = context.keys();

  logger.debug(`Found ${components.length} components`);
  components.map(path => {
    const module = context<{ default: { options?: Vue.ComponentOptions<any> } & VueConstructor }>(path);

    const component = module.default;
    const name = (component.options && component.options.name) || component.name;

    logger.debug(`Registering component ${name}`);

    Vue.component(name, component);
  });
}
